/** Yin palm (fx 'shadow'): violet wisps and drifting dark motes. */
import { registerFx } from './registry';

const R = Math.random;

registerFx('shadow', (host) => ({
  skill: ({ src, tgt, s, sx, sy, tx, ty }) => {
    host.swingArc(src, s.aoe ? 'spin' : 'palm', '176,90,220', s.aoe ? 1.3 : 1);
    const [cx, cy] = s.aoe || !tgt ? [sx, sy] : [tx, ty];
    for (let k = 0; k < 24; k++) {
      const a = R() * Math.PI * 2;
      const d = R() * (s.aoe ? s.aoe * 20 : 12);
      host.parts.push({
        x: cx + Math.cos(a) * d,
        y: cy - 12 + Math.sin(a) * d * 0.5,
        vx: Math.cos(a) * 20,
        vy: -25 - R() * 30,
        g: 0,
        t: 0,
        life: 0.7 + R() * 0.4,
        c: R() < 0.5 ? '#7a2a9a' : R() < 0.5 ? '#e86aa8' : '#2a0e30',
        s: R() < 0.4 ? 2 : 1,
        drag: 1,
      });
    }
    host.sfx.swing();
  },
}));
